/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudWireIcon20Regular = forwardRef('NetCloudWireIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.25 15h-4a4.875 4.875 0 0 1-1.43-9.497A5.376 5.376 0 0 1 13.948 4H14a5.5 5.5 0 1 1 0 11h-3.25v2.5h4.5a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h4.5V15ZM5.257 6.136a3.875 3.875 0 0 1 7.507-1.098.75.75 0 0 0 .787.487A4 4 0 1 1 14 13.5H5.302a3.375 3.375 0 0 1-.638-6.675.75.75 0 0 0 .592-.689Z" })));
});
